import { render, staticRenderFns } from "./knowledgeList2.vue?vue&type=template&id=b802bc44&scoped=true"
import script from "./knowledgeList2.vue?vue&type=script&lang=js"
export * from "./knowledgeList2.vue?vue&type=script&lang=js"
import style0 from "./knowledgeList2.vue?vue&type=style&index=0&id=b802bc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b802bc44",
  null
  
)

export default component.exports